import React from 'react';
import { Clock, Users, Award, TrendingUp} from 'lucide-react';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
    const {t} = useTranslation();

    return (
        <div className='bg-gray-50 -mt-16 pt-16'>
            <section className='bg-gray-900 text-white py-12 sm:py-20'>
                <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
                    <div className='text-center'>
                        <h1 className='text-3xl font-extrabold sm:text-4xl md:text-5xl lg:text-6xl'>
                            {t("aboutUs.title")}
                        </h1>
                        <p className="mt-4 sm:mt-6 max-w-2xl mx-auto text-lg sm:text-xl text-gray-300 px-4 sm:px-0">
                            {t("aboutUs.subtitle")}
                        </p>
                    </div>
                </div>
            </section>

            <section className='py-12 sm:py-16 px-4 sm:px-6'>
                <div className='max-w-7xl mx-auto'>
                    <div className='grid md:grid-cols-2 gap-8 md:gap-12'>
                        <div className="bg-white p-6 sm:p-8 rounded-lg shadow-sm">
                            <h2 className='text-2xl sm:text-3xl font-bold mb-4'>{t("aboutUs.mission.title")}</h2>
                            <p className='text-gray-600 leading-relaxed'>
                                {t("aboutUs.mission.description")}
                            </p>
                        </div>
                        <div className="bg-white p-6 sm:p-8 rounded-lg shadow-sm">
                            <h2 className='text-2xl sm:text-3xl font-bold mb-4'>{t("aboutUs.vision.title")}</h2>
                            <p className='text-gray-600 leading-relaxed'>
                                {t("aboutUs.vision.description")}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-12 sm:py-16 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8 sm:mb-12">{t("aboutUs.values.title")}</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
                        <div className="text-center bg-gray-50 p-6 rounded-lg shadow-sm">
                            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Users className="h-8 w-8 text-blue-600" />
                            </div>
                            <h3 className="text-xl font-semibold mb-2">{t("aboutUs.values.customerFocus.title")}</h3>
                            <p className="text-gray-600">{t("aboutUs.values.customerFocus.description")}</p>
                        </div>
                        <div className="text-center bg-gray-50 p-6 rounded-lg shadow-sm">
                            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                                <TrendingUp className="h-8 w-8 text-blue-600" />
                            </div>
                            <h3 className="text-xl font-semibold mb-2">{t("aboutUs.values.innovation.title")}</h3>
                            <p className="text-gray-600">{t("aboutUs.values.innovation.description")}</p>
                        </div>
                        <div className="text-center bg-gray-50 p-6 rounded-lg shadow-sm">
                            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Award className="h-8 w-8 text-blue-600" />
                            </div>
                            <h3 className="text-xl font-semibold mb-2">{t("aboutUs.values.excellence.title")}</h3>
                            <p className="text-gray-600">{t("aboutUs.values.excellence.description")}</p>
                        </div>
                        <div className="text-center bg-gray-50 p-6 rounded-lg shadow-sm">
                            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                                <Clock className="h-8 w-8 text-blue-600" />
                            </div>
                            <h3 className="text-xl font-semibold mb-2">{t("aboutUs.values.reliability.title")}</h3>
                            <p className="text-gray-600">{t("aboutUs.values.reliability.description")}</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default AboutUs;